import { render, staticRenderFns } from "./RevenueItemCard.vue?vue&type=template&id=55a2bb1d&scoped=true"
import script from "./RevenueItemCard.vue?vue&type=script&setup=true&lang=js"
export * from "./RevenueItemCard.vue?vue&type=script&setup=true&lang=js"
import style0 from "./RevenueItemCard.vue?vue&type=style&index=0&id=55a2bb1d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55a2bb1d",
  null
  
)

export default component.exports